import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loader from '../Loader';
import JsonData from '../../json';

const devEnv = process.env.NODE_ENV !== "production";
const { REACT_APP_DEV_URL, REACT_APP_PROD_URL } = process.env;
let url = "http://localhost:5002";

const Section3 = () => {
    let navigate = useNavigate();
    let [currentImage, setcurrentImage] = useState(0);
    let [sectionImage, setSectionImage] = useState([]);
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        //ajax call
        setLoading(true);
            setSectionImage(JsonData["first-section"]);
            setLoading(false);
    }, []);

    let renderPage = (id) => {
        navigate(`/product/${id}`, {
            state: { id: id, }
        });
    };

    let shiftImages = (direction) => {
        if (currentImage == -1 || currentImage >= 3) {
            setcurrentImage(0);
        }
        if ((currentImage >= 0 && currentImage <= 3)) {
            if (direction === 'L') {
                setcurrentImage(currentImage - 1);
            }
            else {
                setcurrentImage(currentImage + 1);
            }
        }
    };

    return (
        <>
            {!loading ?
                <div className="section3">
                    <div className="section3_grid_inner" style={{ transform: `translateX(-${currentImage * 350}px)` }}>
                        {sectionImage.map((data) => (
                            <div style={{ textAlign: 'center' }} key={data.id} onClick={() => { renderPage(data.id) }}>
                                <img className="section3_image" src={data.image} alt={data.image} />
                                <h3>{data.name}</h3>
                            </div>
                        ))}
                    </div>
                    <button className="section3_button_left" onClick={() => { shiftImages('L') }}>&larr;</button>
                    <button className="section3_button_right" onClick={() => { shiftImages('R') }}>&rarr;</button>
                </div> :
                <Loader />}
        </>
    )
};

export default Section3;